import React from 'react';
import {UserNewView} from './view';

interface UserNewContainerProps {
  createUser: Function;
}

export const UserNewContainer = (props: UserNewContainerProps) => {
  return <UserNewView {...props} />;
};
